/**=========================================================
 * Module: webdav.js
 * WebDAV Controller
 =========================================================*/

 App.controller("WebdavController", ["$rootScope", "$scope", "$state", "$translate", "$window", "$localStorage", "$timeout", "toggleStateService", "Restangular", "DataService", "ngDialog",
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog) 
 {
   "use strict";

   $scope.page = {
       title: 'WebDAV',
       subTitle: 'https://webdav.aqrate.biz'
   }

   $scope.path = $state.params.filter.replace(/~2F/g, '/')
   if($scope.path.endsWith('/')) $scope.path=$scope.path.substr(0, $scope.path.length-1)
   
   $scope.paths = $scope.path.split('/')

   $scope.breadcrumbs = [{
       name: 'webdav.aqrate.biz',
       path: '/'
   }]

   var p = ''
   for(var i=0; i<$scope.paths.length; i++){
       if($scope.paths[i]){
           p += $scope.paths[i] + '/'
            $scope.breadcrumbs.push({
                name: $scope.paths[i],
                path: p
            })
        }
   }

   $scope.items = []
   $scope.loading = true;
   if($scope.path){
    D.call('webdav', 'get', null, {path:$scope.path}).then(function(resp){
        $scope.loading = false
        for(var i=0; i<resp.length; i++){
                if(resp[i].filename!='/'+$scope.path){
                    $scope.items.push(resp[i])
                }
        }
    })
   } else {
       $scope.items = [
           { filename: '/aag', basename: 'aag', type: 'directory', lastmod: ''}
       ]
   }

   $scope.webdavImport = function(){
    $scope.importing = true
    $scope.imported = false
    D.save('action', { id: 'ImportForAAG', webdavCopy: true }).then(function(resp){
        D.save('action', { id: 'ImportForAAG' }).then(function(resp){
            $scope.importing = false
            $scope.imported = true
        })
    })
   }

   $scope.webdavReset = function(){
    ngDialog.openConfirm({
        template: '/app/views/entities/confirm.html',
        className: 'ngdialog-theme-default',
        scope: $scope
    }).then(function (value) {
        let filename = $window.prompt('Enter the name of the file that caused the error (with .zip)')
        $scope.resetting = true
        $scope.resetted = false
        D.save('action', { id: 'ResetImportAAG', filename: filename }).then(function(resp){
            $scope.resetting = false
            $scope.resetted = true
        })
    })
   }

 }
]);
